import type { AuthenticationAccessRight } from "src/authentication/objects/AuthenticationToken";

export const ListAccessRight = {
  VIEW_LISTS: ({ menuDisplayLevel }) => menuDisplayLevel === 3,
} satisfies Record<string, AuthenticationAccessRight>;

/**
 * @deprecated
 */
export default ListAccessRight;
